// @flow

import styled from 'styled-components';
import { SEMIBOLD } from '../../../../helpers/fontWeight';
import type { Theme } from '../../../../types';
import DefaultPrice from '../../../price';

const FromPrice = styled<typeof DefaultPrice, Theme, _>(DefaultPrice)`
  color: ${props => props.theme.carblock.fromPrice.color};
  font-size: ${props => props.theme.carblock.fromPrice.fontSize};
  font-weight: ${SEMIBOLD};
  text-decoration: line-through;
  margin-right: 0.5rem;
  white-space: nowrap;
`;

export default FromPrice;
